/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_BusinessBrandingDTO } from '../models/Routemize_DTOs_BusinessBrandingDTO';
import type { Routemize_DTOs_UpdateBusinessBrandingDTO } from '../models/Routemize_DTOs_UpdateBusinessBrandingDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessBrandingService {
    /**
     * @returns Routemize_DTOs_BusinessBrandingDTO OK
     * @throws ApiError
     */
    public static getApiAppBusinessBrandingGet(): CancelablePromise<Routemize_DTOs_BusinessBrandingDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/businessBranding/get',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BusinessBrandingDTO OK
     * @throws ApiError
     */
    public static postApiAppBusinessBrandingCreate(
        requestBody?: Routemize_DTOs_BusinessBrandingDTO,
    ): CancelablePromise<Routemize_DTOs_BusinessBrandingDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/businessBranding/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BusinessBrandingDTO OK
     * @throws ApiError
     */
    public static putApiAppBusinessBrandingUpdate(
        requestBody?: Routemize_DTOs_UpdateBusinessBrandingDTO,
    ): CancelablePromise<Routemize_DTOs_BusinessBrandingDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/businessBranding/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
